import * as React from 'react';
import BybitMobileTradingInterface from '../Trading/BybitMobileTradingInterface';

export default function TradeTab() {
  return <BybitMobileTradingInterface />;
}
